import { User, Mail, LogOut } from 'lucide-react';
import authService from '../services/authService';
import { useNavigate } from 'react-router-dom';

interface ProfilePageProps {
  user?: any;
  onLogout: () => void;
}

export default function ProfilePage({ user, onLogout }: ProfilePageProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    onLogout();
    navigate('/login');
  };

  if (!user) {
    return (
      <div className="text-center py-12">
        <p className="text-muted">Loading user data...</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Profile</h1>

      {/* User Info Card */}
      <div className="card p-6 space-y-6">
        <div className="flex items-center gap-4">
          {user.image_url ? (
            <img 
              src={user.image_url} 
              alt={user.display_name} 
              className="w-20 h-20 rounded-full"
            />
          ) : (
            <div className="w-20 h-20 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
              <User className="w-10 h-10 text-primary-500" />
            </div>
          )}
          <div>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
              {user.display_name || user.username}
            </h2>
            <p className="text-muted">@{user.username}</p>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-dark-border pt-6 space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="w-5 h-5 text-muted" />
            <div>
              <p className="text-sm text-muted">Email</p>
              <p className="font-medium text-gray-900 dark:text-white">{user.primary_email}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <User className="w-5 h-5 text-muted" />
            <div>
              <p className="text-sm text-muted">User ID</p>
              <p className="font-mono text-sm text-gray-900 dark:text-white">{user.id}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Favorite Games Placeholder */}
      <div className="card p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900 dark:text-white">My Favorites</h3>
        <p className="text-muted text-center py-8">
          Your favorite games will appear here
        </p>
      </div>

      {/* Logout Button */}
      <div className="card p-6">
        <button
          onClick={handleLogout}
          className="w-full btn-secondary flex items-center justify-center gap-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20"
        >
          <LogOut className="w-5 h-5" />
          Logout
        </button>
      </div>
    </div>
  );
}

